<template>
  <!-- 全部直播 -->
  <div class="container">
    <div class="category">
      <div class="category-wrap" @click="tab = -1" :class="{ active: tab == -1 }">
        <div class="category-card">全部直播</div>
      </div>
      <div class="category-wrap" @click="tab = 0" :class="{ active: tab == 0 }">
        <div class="category-card">即将上线</div>
      </div>
      <div class="category-wrap" @click="tab = 1" :class="{ active: tab == 1 }">
        <div class="category-card">正在直播</div>
      </div>
      <div class="category-wrap" @click="tab = 2" :class="{ active: tab == 2 }">
        <div class="category-card">观看回放</div>
      </div>
    </div>
    <div v-if="!list.length" class="no-list">
      <img src="@/assets/all_blank/blank@2x.png" alt=""/>
      <div>暂无直播</div>
    </div>
    <div v-else class="container-list">
      <div class="streaming-list">
        <div v-for="item in list" :key="item.id" class="streaming-wrap">
          <div class="streaming-img">
            <img :src="item.img_pc" alt="" @click="streamClick(item.id)"/>
          </div>
          <div v-if="item.status == 1">
            <div class="streaming-status">
              <div class="status-left">
                <img src="@/assets/zbing.png" alt=""/>正在直播
              </div>
            </div>
          </div>
          <div v-if="item.status == 2" class="is-end">
            <div v-if="item.is_playback != 1" class="streaming-status1">
              <div class="status-left">已结束</div>
            </div>
            <div v-if="item.is_playback == 1" class="streaming-status2">
              <div class="status-left">观看回放</div>
            </div>
          </div>
          <div v-if="item.status == 0" class="not-start">
            <div v-if="item.isAppointment" class="streaming-status2">
              <div class="status-left">已预约</div>
            </div>
            <div v-else class="streaming-status1" @click="streamingSubscribe(item.id, item)">
              <div class="status-left">预约</div>
            </div>
          </div>
          <div class="streaming-time"><img src="@/assets/time.png" alt=""/>直播时间：{{ item.start_at }}</div>
        </div>
        <!-- <div class="container">
          <div class="category">
            <div class="category-wrap" @click="tab = -1" :class="{ active: tab == -1 }">
              <div class="category-card">全部直播</div>
            </div>
            <div class="category-wrap" @click="tab = 0" :class="{ active: tab == 0 }">
              <div class="category-card">即将上线</div>
            </div>
            <div class="category-wrap" @click="tab = 1" :class="{ active: tab == 1 }">
              <div class="category-card">正在直播</div>
            </div>
            <div class="category-wrap" @click="tab = 2" :class="{ active: tab == 2 }">
              <div class="category-card">观看回放</div>
            </div>
          </div>
          <div v-if="!list.length" class="no-list">
            <img src="@/assets/all_blank/blank@2x.png" alt=""/>
            <div>暂无直播</div>
          </div>
          <div v-else class="container-list">
            <div class="streaming-list">
              <div v-for="item in list" :key="item.id" class="streaming-wrap">
                <div class="streaming-img">
                  <img :src="item.img_pc" alt="" @click="$router.push('/streaming-page/' + item.id)"/>
                </div>
                <div v-if="item.status == 1">
                  <div class="streaming-status">
                    <div class="status-left">
                      <img src="@/assets/zbing.png" alt=""/>正在直播
                    </div>
                  </div>
                </div>
                <div v-if="item.status == 2" class="is-end">
                  <div v-if="item.is_playback != 1" class="streaming-status1">
                    <div class="status-left">已结束</div>
                  </div>
                  <div v-if="item.is_playback == 1" class="streaming-status2">
                    <div class="status-left">观看回放</div>
                  </div>
                </div>
                <div v-if="item.status == 0" class="not-start">
                  <div v-if="item.isAppointment" class="streaming-status2">
                    <div class="status-left">已预约</div>
                  </div>
                  <div v-else class="streaming-status1" @click="streamingSubscribe(item.id, item)">
                    <div class="status-left">预约</div>
                  </div>
                </div>
                <div class="streaming-time"><img src="@/assets/time.png" alt=""/>直播时间：{{ item.start_at }}</div> -->
      </div>
    </div>
    <login-name ref="login"></login-name>
  </div>
</template>

<script>
import {
  getIndexData,
  getStreamingList,
  streamingSubscribe,
} from "@/api/stream";
import {mapState} from "vuex";
import moment from "moment/moment";
import LoginName from '@/views/login/index.vue';

export default {
  name: "",
  components: {
    LoginName
  },
  computed: {
    ...mapState({
      userStatus: (state) => state.user.status,
      userId: (state) => state.user.id,
      username: (state) => state.user.name,
      user: (state) => state.user
    }),
  },
  data() {
    return {
      bannerList: [],
      recommendList: [],
      finished: false,
      list: [],
      page: 1,
      tab: -1,
    };
  },
  watch: {
    tab: function () {
      this.list = []
      this.getStreamingList(1);
    },
  },
  created() {
    getIndexData().then((res) => {
      if (res.code == 200) {
        this.bannerList = res.data.carousel.filter((item) => item.status == 1);
        this.recommendList = res.data.recommend.splice(0, 2);
      }
    });
    this.getStreamingList(this.page);
  },
  methods: {
    streamClick(id) {
      if (!this.$store.getters.token) {
        this.$refs['login'].showlogin()
      } else {
        this.$router.push('/streaming-page/' + id)
      }
    },
    jumpTo(href) {
      if (!href) return;
      window.open(href);
    },
    streamingSubscribe(id, item) {
      streamingSubscribe({id}).then(({code = -1}) => {
        if (code == 200) {
          item.live_fans = 1;
          this.$message({message: "预约成功", type: "success",});
          this.list = this.list.map(o => {
            if (o.id != id) return o;
            o.isAppointment = true;
            return o;
          });
        }
      });
    },
    loadMore() {
      if (this.finished) return;
      this.getStreamingList(this.page);
    },
    getStreamingList(page) {
      const loading = this.$loading({lock: true,});
      const that = this;
      getStreamingList({status: this.tab == -1 ? undefined : this.tab, page: page,}).then(({code = -1, data = {}}) => {
        if (code == 200) {
          if (data.data.length === 0) return;
          const list = data.data.map(o => {
            o["isAppointment"] = (o.live_fans.length > 0 && o.live_fans.filter(o => o.user_id == that.userId).length > 0);
            o.start_at = moment(o.start_at, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm")
            return o;
          });
          this.list = this.list.concat(list);
          this.page = data.current_page;
          if (this.list.length < 15) this.finished = true;
        }
      }).finally(() => loading.close());
    },
  },

};
</script>

<style lang="scss" scoped>
.container {
  margin: 0 auto;
  display: flex;
  flex-flow: column;
  // width: 1330px;
  width: 1200px;
  padding-left: 20px;
  //justify-content: center;
  //width:100%;
}

.category {
  display: flex;
  // margin-left: 50px;
  margin-top: 20px;
  // padding-left:8px;

  .category-wrap {
    cursor: pointer;
    font-size: 20px;
    font-weight: bold;
    height: 50px;
    line-height: 50px;
    border-bottom: 4px solid transparent;
    text-align: center;
    white-space: nowrap;
    margin-right: 40px;
    color: rgb(0, 0, 0);
    font-family: SourceHanSansCN-Medium;
    width: 125px;
  }

  .active {
    //background-color: #a7caac;
    background-color: rgb(158, 203, 169);
    border: 1px solid #fff;
    width: 125px;
    height: 50px;
    border-radius: 30px;
    line-height: 45px;
    color: white;
    font-size: 20px;

    .category-card {
      background-color: #a7caac;
      border-bottom: 3px solid #fff;
      color: #fff;
      width: 100%;
      height: 100%;
      border-radius: 30px;
    }
  }

  .category-wrap:nth-child(1) {
    margin-right: 20px;
    border-radius: 30px;
    padding-bottom: 3px;
  }

  .category-wrap:nth-child(2) {
    border-radius: 30px;
    padding-bottom: 3px;
  }

  .category-wrap:nth-child(3) {
    border-radius: 30px;
    padding-bottom: 3px;
  }

  .category-wrap:nth-child(4) {
    border-radius: 30px;
    padding-bottom: 3px;
  }
}

.streaming-status {
  z-index: 10;
  width: 100px;
  height: 50px;
  font-size: 10px;
  content: "正在直播";
  display: block;
  height: 0;
  border-width: 0 16px 16px;
  border-style: none solid solid;
  border-color: transparent transparent #9f0145;
  position: absolute;
  -moz-transform: rotate(-45deg);
  -webkit-transform: rotate(135deg);
  -o-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  left: 272px;
  top: 135px;
  width: 95px;
  color: #fff;
  text-align: center;

  .status-left {
    -webkit-transform: rotate(180deg);
    margin-top: -1px;

    img {
      width: 10px;
      margin-right: 1px;
    }
  }
}

.container-list::-webkit-scrollbar {
  display: none;
}

.container-list {
  display: flex;
  flex-flow: nowrap;
  justify-content: center;
  overflow-x: hidden;

  .streaming-list {
    display: flex;
    flex-flow: wrap;
    align-items: center;
    // width:1300px;
    width: 1200px;
    //width: 100vw;
    margin-top: 20px;
    // margin-left: 50px;
    overflow: hidden;
    box-sizing: border-box;
    //修改
    flex: 0 0 auto;

    .streaming-wrap {
      cursor: pointer;
      border-radius: 15px;
      display: flex;
      flex-flow: column;
      align-items: center;
      position: relative;
      width: 360px;
      height: auto;
      // box-sizing: border-box;
      margin: 10px 20px;
      float: left;

      .streaming-img {
        width: 100%;
        height: 180px;
        border-radius: 12px;
        margin-right: 20px;
        border: 2px solid #a7caac;
        padding-bottom: 5px;
        background-color: rgba(255, 255, 255, 0.9);

        img {
          width: 100%;
          height: 100%;
          border-radius: 10px;
          border-bottom: 2px solid #a7caac;
          object-fit: cover;
        }
      }

      .streaming-info {
        width: calc(100% - 310px);

        .streaming-title {
          font-size: 20px;
          color: #444444;
          font-weight: 500;
          height: 55px;
          line-height: 30px;
          padding-right: 30px;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
        }

        .streaming-time {
          color: #999999;
          font-size: 16px;
          line-height: 16px;
          padding: 80px 0 30px;

          img {
            width: 15px;
            vertical-align: middle;
          }
        }

        .streaming-status {
          font-size: 18px;

          .status-left {
            img {
              width: 21px;
              margin-right: 10px;
            }
          }
        }
      }

      .streaming-btn {
        position: absolute;
        right: 30px;
        bottom: 30px;
        height: 34px;
        width: 100px;
        line-height: 34px;
        font-size: 16px;
        text-align: center;
        color: #a00145;
        border: 1px solid rgba(160, 1, 69, 1);
        border-radius: 6px;
      }

      .is-end {
        .streaming-status1 {
          z-index: 10;
          width: 100px;
          height: 50px;
          font-size: 10px;
          content: "已结束";
          display: block;
          height: 0;
          border-width: 0 18px 18px;
          border-style: none solid solid;
          border-color: transparent transparent #c9c9c9;
          position: absolute;
          -moz-transform: rotate(-45deg);
          -webkit-transform: rotate(135deg);
          -o-transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          left: 282px;
          top: 139px;
          width: 85px;
          color: white;
          /*background-color: #9F0145;*/
          .status-left {
            text-align: center;
            -webkit-transform: rotate(180deg);

            img {
              width: 10px;
              margin-right: 1px;
            }
          }
        }

        .streaming-status2 {
          z-index: 10;
          width: 100px;
          height: 50px;
          font-size: 10px;
          content: "直播回放";
          display: block;
          height: 0;
          border-width: 0 18px 18px;
          border-style: none solid solid;
          border-color: transparent transparent #ffb42c;
          position: absolute;
          -moz-transform: rotate(-45deg);
          -webkit-transform: rotate(135deg);
          -o-transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          left: 282px;
          top: 139px;
          width: 85px;
          color: white;
          /*background-color: #9F0145;*/
          .status-left {
            -webkit-transform: rotate(180deg);
            text-align: center;

            img {
              width: 10px;
              margin-right: 1px;
            }
          }
        }

        .streaming-status {
          color: #666666;
        }
      }

      .not-start {
        .streaming-status1 {
          z-index: 10;
          width: 100px;
          height: 50px;
          font-size: 10px;
          content: "预约直播";
          display: block;
          height: 0;
          border-width: 0 18px 18px;
          border-style: none solid solid;
          border-color: transparent transparent rgb(12, 90, 31);
          position: absolute;
          -moz-transform: rotate(-45deg);
          -webkit-transform: rotate(135deg);
          -o-transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          left: 282px;
          top: 139px;
          width: 85px;
          color: white;
          /*background-color: #9F0145;*/
          .status-left {
            text-align: center;
            -webkit-transform: rotate(180deg);

            img {
              width: 10px;
              margin-right: 1px;
            }
          }
        }

        .streaming-status2 {
          z-index: 10;
          width: 100px;
          height: 50px;
          font-size: 10px;
          content: "预约直播";
          display: block;
          height: 0;
          border-width: 0 18px 18px;
          border-style: none solid solid;
          border-color: transparent transparent #a7caac;
          position: absolute;
          -moz-transform: rotate(-45deg);
          -webkit-transform: rotate(135deg);
          -o-transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          left: 282px;
          top: 139px;
          width: 85px;
          color: white;
          /*background-color: #9F0145;*/
          .status-left {
            -webkit-transform: rotate(180deg);
            text-align: center;

            img {
              width: 10px;
              margin-right: 1px;
            }
          }
        }

        .streaming-status {
          color: #01a014;
        }
      }
    }

    /*.streaming-wrap:nth-child(2n) {*/
    /*  margin-left: 58px;*/
    /*}*/
  }
}

.no-list {
  margin-left: 50px;
  text-align: center;
  font-size: 18px;
  color: #979da9;
  padding: 200px 0;

  img {
    width: 170px;
    margin-bottom: 30px;
  }
}

.streaming-time {
  color: #066103;
  font-size: 13px;
  line-height: 16px;
  padding: 10px 0 10px;
  //background-color: rgba(162, 212, 161, 0.7);
  background: #DBECD9;
  width: 100%;
  border-radius: 10px;
  text-align: center;
  margin-left: -20px;
  margin-top: 10px;

  img {
    margin-top: -3px;
    margin-left: 10px;
    margin-right: 10px;
    width: 15px;
    vertical-align: middle;
  }
}

.search-container {
  width: 1460px;
  margin: 20px auto;
  background: #fff;
  overflow: hidden;
  position: relative;

  .time-line {
    width: 3px;
    height: 100%;
    min-height: 500px;
    background: rgba(160, 1, 69, 1);
    margin: 57px 0;
    position: absolute;
    left: 130px;
    top: 0;
  }

  .streaming-list {
    width: 1000px;
    margin: 0 230px;
    min-height: 600px;

    .list-nav {
      display: flex;
      font-size: 18px;
      color: #333333;
      border-bottom: 1px solid #e6e6e6;
      padding: 0 70px;
      margin-top: 30px;

      .nav-wrap {
        cursor: pointer;
        margin-right: 82px;
      }

      .active {
        border-bottom: 4px solid #a00145;
      }
    }

    .date-wrap {
      position: relative;

      .date-tag {
        position: absolute;
        left: -180px;
        top: 10px;
        width: 50px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        color: #fff;
        border-radius: 6px;
        background: #a00145;
        box-sizing: border-box;
      }

      .date-tag::after {
        position: absolute;
        left: 50px;
        top: 10px;
        content: " ";
        box-sizing: content-box;
        border: 4px solid rgba(0, 0, 0, 0);
        border-left: 4px solid #a00145;
      }
    }

    .streaming-wrap {
      cursor: pointer;
      border-bottom: 1px solid #f0f0f0;
      padding: 20px 185px 20px 0;
      box-sizing: border-box;
      display: flex;
      position: relative;

      .record-time {
        position: absolute;
        left: -85px;
        top: 60px;
        font-size: 14px;
        color: #979daa;
      }

      .streaming-img {
        width: 180px;
        height: 110px;
        margin-right: 21px;
        border-radius: 10px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .streaming-info {
        width: calc(100% - 221px);

        .streaming-title {
          font-size: 18px;
          color: #444;
          height: 38px;
        }

        .sub-title {
          font-size: 14px;
          color: #666666;
          line-height: 16px;
          margin-bottom: 28px;
          height: 18px;
        }

        .sub-info {
          display: flex;
          justify-content: space-between;
          line-height: 18px;
          align-items: center;
          position: relative;

          .left {
            font-size: 14px;
            color: #666666;
          }

          .right {
            font-size: 14px;
            color: #01a014;
            display: flex;
          }

          .watch-btn {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 70px;
            height: 24px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(160, 1, 69, 1);
            border-radius: 4px;
            font-size: 14px;
            font-weight: 500;
            color: rgba(160, 1, 69, 1);
            text-align: center;
            line-height: 24px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .no-list {
    margin-left: 50px;
    text-align: center;
    font-size: 18px;
    color: #979da9;
    padding: 200px 0;

    img {
      width: 170px;
      margin-bottom: 30px;
    }
  }
}
</style>
